module.exports = __webpack_public_path__ + "img/xnr7.94b7b8d3.jpg";